import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { Button, Paper } from "@material-ui/core";
import { useStores } from "@hooks";
import { ACCESS_DOMAINS } from "@client";
import { revokeImpersonationSession } from "@query/impersonationApi";
import { getAdminPanelUsersUrl } from "./impersonationExit";
import useStyle from "./ImpersonationBanner.style";

export const ImpersonationBanner = observer(() => {
  const { t } = useTranslation();
  const classes = useStyle();
  const { userStore } = useStores();
  const session = userStore.impersonation;

  if (!session) return null;

  const actor =
    session.actor?.name ||
    session.actor?.email ||
    session.actor?.id ||
    t("impersonation.banner.fallback_actor");
  const subject =
    userStore.data?.fullname || userStore.data?.email || session.subjectId;

  const exit = async () => {
    try {
      await revokeImpersonationSession(session.sessionId);
    } finally {
      await userStore.clearUserData();
      window.location.replace(getAdminPanelUsersUrl(ACCESS_DOMAINS.api));
    }
  };

  return (
    <Paper
      role="alert"
      square
      elevation={3}
      className="w-full px-4 py-2 flex items-center justify-between"
    >
      <span>{t("impersonation.banner.viewing_as", { subject, actor })}</span>
      <Button
        color="primary"
        variant="contained"
        size="small"
        onClick={exit}
        className={classes.exitButton}
      >
        {t("impersonation.banner.exit")}
      </Button>
    </Paper>
  );
});
